module.exports = __webpack_public_path__ + "img/gs.bd541b14.svg";